module.exports = __webpack_public_path__ + "static/media/data.c9dbcad5.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/data.png
// module id = 242
// module chunks = 0